export default "__VITE_ASSET__f2f887ad__"